import { t } from "@lingui/macro";

import { Avatar } from "@whoosh/design-system/src/components/display/Avatar";
import {
  VStack,
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

import { PatronEditBooking } from "../../../../types";

type AddNewPlayerTileProps = {
  onPress: (round: PatronEditBooking.RoundPlayer) => void;
  playerNounSingular: string;
};
export const AddNewPlayerTile = ({
  onPress,
  playerNounSingular,
}: AddNewPlayerTileProps) => {
  return (
    <VStack
      paddingBottom={2}
      marginBottom={3}
      borderBottomWidth={1}
      borderBottomColor="outline-default"
    >
      <Pressable
        onPress={() => {
          onPress({
            id: null,
            clientType: "unknownCustomer",
            firstName: null,
            lastName: null,
          });
        }}
      >
        <HStack
          alignItems="center"
          justifyContent="space-between"
          mb={2}
          py={2}
        >
          <HStack alignItems="center" gap={2}>
            <Avatar type="unknownCustomer" size={"sm"} />
            <Text variant="mainBaseSemiBold">
              {t`New ${playerNounSingular}`}
            </Text>
          </HStack>
        </HStack>
      </Pressable>
    </VStack>
  );
};
